import React, { useMemo } from "react";

 
 
import { useCurrentStateAndParams } from "@uirouter/react";

import { SearchOverviewGraphConnected } from "app/pages/website-analysis/traffic-sources/search/tabs/SearchOverviewGraph/SearchOverviewGraph";
import { SearchOverviewTopWidgetCompareContainer } from "app/pages/website-analysis/traffic-sources/search/tabs/SearchOverviewTraffic/SearchOverviewTopWidgetCompareContainer";
import { SearchOverviewTopWidgetSingleContainer } from "app/pages/website-analysis/traffic-sources/search/tabs/SearchOverviewTraffic/SearchOverviewTopWidgetSingleContainer";
import { SearchOverviewTrafficCompare } from "app/pages/website-analysis/traffic-sources/search/tabs/SearchOverviewTraffic/SearchOverviewTrafficCompare";
import { SearchOverviewTrafficSingle } from "app/pages/website-analysis/traffic-sources/search/tabs/SearchOverviewTraffic/SearchOverviewTrafficSingle";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import CountryService from "app/services/CountryService";
import DurationService from "app/services/DurationService";
import { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";

const COMPONENTS = {
    single: SearchOverviewTopWidgetSingleContainer,
    compare: SearchOverviewTopWidgetCompareContainer,
};

// THE OLD OVERVIEW PAGE
// TODO: Delete this after we will release the new page

export const SearchOverviewContainer: React.FunctionComponent = () => {
    const { params } = useCurrentStateAndParams();
    const apiParams = React.useMemo(() => proNavigator.getApiParams(params), [params]);
    const { webSource, key } = params;
    const durationObject = React.useMemo(() => DurationService.getDurationData(params.duration), [params.duration]);

    const subtitleFilters = React.useMemo(
        () => [
            {
                filter: "date",
                value: {
                    from: durationObject.raw.from.valueOf(),
                    to: durationObject.raw.to.valueOf(),
                },
            },
            {
                filter: "country",
                countryCode: params.country,
                value: CountryService.getCountryById(params.country).text,
            },
        ],
        [params, durationObject],
    );

    const isCompareMode = key.split(",").length > 1;
    const isMobileWeb = webSource === devicesTypes.MOBILE;
    const isTotal = webSource === devicesTypes.TOTAL;
    const isDesktop = webSource === devicesTypes.DESKTOP;

    const Component = useMemo(() => {
        if (!isCompareMode) {
            return COMPONENTS.single;
        } else {
            return COMPONENTS.compare;
        }
    }, [isCompareMode]);
    return (
        <>
            {Component ? (
                <Component
                    {...{
                        apiParams,
                        subtitleFilters,
                        isTotal,
                    }}
                />
            ) : null}
            <SearchOverviewGraphConnected
                isSingle={!isCompareMode}
                isMobileWeb={isMobileWeb}
                isDesktop={isDesktop}
                isTotal={isTotal}
            />
            {!isMobileWeb && !isCompareMode ? <SearchOverviewTrafficSingle params={params} /> : null}
            {!isMobileWeb && isCompareMode ? <SearchOverviewTrafficCompare params={params} /> : null}
        </>
    );
};
